import React from 'react'
import { Link } from 'react-router-dom'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import { Button, Form, Message} from 'semantic-ui-react'
import { confirmEmail, isAuthenticated } from '../../services/self'
import logo from '../../Nlogo.png'

 export default class ConfirmEmail extends React.Component {

   state = {
     isSubmitting: false,
     signedIn: false,
     errorMessage: '',
     isOpen: false,
     code: ''
   }
confirmEmail = (event, serializedForm) => this._confirmEmail(event, serializedForm)


   _confirmEmail(event, serializedForm){
     event.preventDefault()
     console.log(`code is: ${this.state.code}`);
     confirmEmail(this.state.code)

   }


   render() {
     return (
    <div className="none">
            <div className="App">
            <div className="Logo">
              <a className="Img-Link" href="#"><Link className="home-link" to='/'><img src={logo} className="App-logo" alt="logo" /></Link></a>
              <a className="Developer-link" href="#"><Link className="home-link" to='/'>Developer</Link></a>
            </div>

            <div className="Navbar-Div">
              <nav className="App-navbar">


                <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
                <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
                <Link className="Centered-link" to='/documentation'>Docs</Link>
                <Link className="Centered-link" to='/tools'>Tools</Link>
                <Link className="Centered-link" to='/community'>Community</Link>

                {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
                {isAuthenticated() ? (<Link className="right" to='' onClick={() => this.logout()}>Log out</Link>) : ''}
                {isAuthenticated() ? '' : (
                <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
                </span>
                )}


              </nav>
            </div>

            <div className="App-banner">

              Newforma World 2018 | October 2 - 5, 2018 | Connecting People, Projects and Information!

            </div>

    <div className="main-content">

      <Form onSubmit={this.confirmEmail} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
        <Form.Input label='Verification Code' name='code' onChange={ (e) => this.setState({ code: e.target.value }) } />
        <Message error content={this.state.errorMessage} />
        <Button primary type='submit'>Confirm New Email</Button>
      </Form>

  </div>
</div>
</div>
)}
}



/** WEBPACK FOOTER **
 ** ./src/pages/ConfirmEmail/index.js
 **/